import React from "react";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="overlay"></div>

      <div className="content">
        <h1>المؤسسة الدولية للاستدامة والتنمية</h1>
        <p>
          نؤمن بأن الاستدامة ليست خيارًا، بل طريقًا نحو مستقبل أكثر وعيًا وتوازنًا.
          نعمل على دعم المشروعات والمبادرات التي تصنع الأثر الحقيقي في التنمية البيئية والمجتمعية.
        </p>
        <a href="#jobs"><button className="btn" >اكتشف المزيد</button></a>
      </div>

      <style>{`
        .hero {
          position: relative;
          width: 100%;
          height: 100vh;
          background-image: url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1600&q=80');
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
          overflow: hidden;
        }

        /* تدرج لوني فوق الخلفية */
        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom right, rgba(0, 60, 120, 0.8), rgba(0, 20, 60, 0.8));
          z-index: 1;
        }

        .content {
          position: relative;
          z-index: 2;
          max-width: 850px;
          padding: 0 20px;
          animation: fadeIn 1.5s ease forwards;
        }

        .content h1 {
          font-size: 3.2rem;
          font-weight: 800;
          line-height: 1.3;
          background: linear-gradient(to right, #4fc3f7, #81d4fa, #e3f2fd);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 1.2rem;
        }

        .content p {
          font-size: 1.2rem;
          color: #e0eaff;
          margin-bottom: 2.5rem;
          line-height: 1.8;
        }

        .btn {
          background: linear-gradient(to right, #2196f3, #1976d2);
          color: #fff;
          font-weight: bold;
          border: none;
          border-radius: 12px;
          padding: 0.9rem 2.2rem;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 0 15px rgba(33, 150, 243, 0.4);
        }

        .btn:hover {
          background: linear-gradient(to right, #42a5f5, #2196f3);
          transform: translateY(-3px);
          box-shadow: 0 0 25px rgba(66, 165, 245, 0.6);
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .content h1 {
            font-size: 2.2rem;
          }
          .content p {
            font-size: 1rem;
          }
        }
      `}</style>
    </section>
  );
}
